<template>
  <div class="history-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.custom_history') }}</span> 
    </div>
    <div class="page-title">{{ $t('breadcrumbs.custom_history') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="customHistory"/>
      </div>
      <div class="page-right">
        <div class="history-block" v-if="getChooseData!==''">
          <div class="mobile-date show-on-pad">
            <select name="" id="" v-model="choosedateIndex">
              <option value="">{{ $t('custom_history_page.choose_date') }}</option>
              <option 
                :value="index"
                v-for="(item,index) in list" 
                :key="item.id"
              >
                {{ moment(item.measure_time).format("YYYY.MM.DD") }}
              </option>
            </select>
          </div>
          <div class="history-detail">
            <div class="detail-left">
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size1') }}</div>
                <div class="item-content">{{ getChooseData.size8 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size2') }}</div>
                <div class="item-content">{{ getChooseData.size49 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size3') }}</div>
                <div class="item-content">{{ getChooseData.size10 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size4') }}</div>
                <div class="item-content">{{ getChooseData.size11 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size5') }}</div>
                <div class="item-content">{{ getChooseData.size12 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size6') }}</div>
                <div class="item-content">{{ getChooseData.heart_rate }}BPM</div>
              </div>
            </div>
            <div class="detail-center">
              <img src="./image/woman.png">
            </div>
            <div class="detail-right">
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size7') }}</div>
                <div class="item-content">{{ getChooseData.size33 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size8') }}</div>
                <div class="item-content">{{ getChooseData.size40 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size9') }}</div>
                <div class="item-content">{{ getChooseData.size43 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size10') }}</div>
                <div class="item-content">{{ getChooseData.size13 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size11') }}</div>
                <div class="item-content">{{ getChooseData.size19 }}CM</div>
              </div>
              <div class="detail-item">
                <div class="item-name">{{ $t('custom_history_page.size12') }}</div>
                <div class="item-content">{{ getChooseData.weight }}KG</div>
              </div>
            </div>
          </div>
          <div class="pc-date hide-on-pad-flex">
            <div 
              class="date-item" 
              :class="{ active: index==choosedateIndex }" 
              v-for="(item,index) in list" :key="item.id"
              @click="showDetail(index)"
            >
              {{ moment(item.measure_time).format("YYYY.MM.DD") }}
            </div>
            <!-- <div class="date-item">2020.01.25</div>
            <div class="date-item">2020.01.25</div>
            <div class="date-item">2020.01.25</div>
            <div class="date-item">2020.01.25</div> -->
          </div>
          <div class="btn-block">
            <div class="btn btn-orange" @click="handleJump">{{ $t('btns.order_custom') }}</div>
          </div>
        </div>
        <div class="no-data" v-else>
          {{ $t('custom_history_page.no_result') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
import { getCustomHistory } from '../../api'
import moment from "moment";

  export default {
    name: 'history',
    components: {
      userSideMenu
    },
    data() {
      return {
        list: [],
        choosedateIndex: 0
      }
    },
    computed: {
      getChooseData() {
        if(this.list.length>0) {
          return this.list[this.choosedateIndex];
        }else{
          return '';
        }
      }
    },
    async created() {
      const res = await getCustomHistory({pages: 1, count: 1000});
      console.log(res);
      this.list = res.body;
    },
    methods: {
      moment,
      handleJump() {
        this.$router.push({ name: 'customForm'});
      },
      showDetail(index) {
        this.choosedateIndex = index;
      }
    }
  }
</script>

<style lang="less" scoped>
.history-page {
  @media (max-width: 992px) {
    background: #F7F8FA;
  }
  .mobile-date {
    select {
      width: 100%;
      color: #707070;
      text-align-last: center;
    }
  }
  .history-detail {
    display: flex;
    flex-direction: row;
    margin-top: 60px;
    background: white;
    @media (max-width: 992px) {
      border-radius: 10px;
      margin-top: 0;
      flex-direction: column;
      margin-top: 20px;
      overflow: hidden;
      box-shadow: 2px 4px 6px 2px rgba(0, 0, 0, 0.1);
      padding: 0 10px;
      padding-bottom: 10px;
      margin-bottom: 30px;
    }
    .detail-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .detail-center {
      width: 500px;
      text-align: center;
      @media (max-width: 992px) {
        display: none;
      }
      img {
        width: 250px;
      }
    }
    .detail-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .detail-item {
      text-align: center;
      flex: 1;
      display: flex;
      flex-direction: column;
      .item-name {
        background: #F0F0F0;
        color: #707070;
        padding: 12px;
        @media (max-width: 992px) {
          text-align: left;
          background: white;
        }
      }
      .item-content {
        color: #EC4F00;
        padding: 20px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        @media (max-width: 992px) {
          border: 1px solid #E6E6E6;
          border-radius: 10px;
          padding: 14px;
        }
      }
    }
  }
  .pc-date {
    margin-top: 100px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    .date-item {
      background: #F0F0F0;
      color: #707070;
      padding: 16px;
      text-align: center;
      margin-right: 30px;
      flex: 0 0 calc(33.333% - 20px);
      margin-bottom: 30px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &.active {
        background: #EC4F00;
        color: white;
      }
    }
  }
  .btn-block {
    border-top: 1px solid #E6E6E6;
    display: flex;
    justify-content: center;
    padding: 50px 0;
    @media (max-width: 992px) {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 10;
      border: 0;
      width: 100%;
      padding: 0;
    }
    .btn {
      width: 125px;
      @media (max-width: 992px) {
        width: 100%;
      }
    }
  }
}
</style>